import {
  ADOBE_SAVED_ITEMS_RECEIVED_FULFILMENT_LABELLED_ITEMS_EVENT_KEY,
  ADOBE_SAVED_ITEMS_RECEIVED_AFS_ITEMS_EVENT_KEY,
  ADOBE_SAVED_ITEMS_RECEIVED_RESTOCKING_SOON_EVENT_KEY,
  ADOBE_EARLY_ACCESS_PRODUCTS_EVENT_KEY
} from "../../../../../../services/analytics/constants";
import getFulfilmentLabelsCount from "./getFulfilmentLabelsCount";
import getAfsLabelsCount from "./getAfsLabelsCount";
import getProductRestockingSoonCount from "./getProductRestockingSoonCount";
import getEarlyAccessProductsCount from "./getEarlyAccessProductsCount";

const getEvents = savedItemProducts =>
  [
    {
      key: ADOBE_SAVED_ITEMS_RECEIVED_FULFILMENT_LABELLED_ITEMS_EVENT_KEY,
      value: getFulfilmentLabelsCount(savedItemProducts)
    },
    {
      key: ADOBE_SAVED_ITEMS_RECEIVED_AFS_ITEMS_EVENT_KEY,
      value: getAfsLabelsCount(savedItemProducts)
    },
    {
      key: ADOBE_SAVED_ITEMS_RECEIVED_RESTOCKING_SOON_EVENT_KEY,
      value: getProductRestockingSoonCount(savedItemProducts)
    },
    {
      key: ADOBE_EARLY_ACCESS_PRODUCTS_EVENT_KEY,
      value: getEarlyAccessProductsCount(savedItemProducts)
    }
  ]
    .filter(({ value }) => value > 0)
    .map(({ key, value }) => ({ [key]: value }));

export default getEvents;
